<template>
  <v-app class="dealer-portal">
  <div class="dealer-signup">
    <!-- Header -->
    <HeaderDealer />
    
    <!-- Main Content -->
    <v-main class="auth-pages" >
      <v-container fluid class="signup-container">
        <v-row justify="center" align="center" class="min-height-screen">
          <v-col cols="12" md="10" lg="8" xl="6">
            <!-- Hero Section -->
            <div class="hero-section text-center mb-8">
              <div class="hero-icon mb-4">
                <v-icon size="80" color="primary" class="material-icons-round">
                  store
                </v-icon>
              </div>
              <h1 class="hero-title">
                Join the AutoSyncX&trade; Dealer Network
              </h1>
              <p class="hero-subtitle">
                Connect with thousands of referral agents and expand your reach.
                Let's get your dealership onboarded in just a few minutes!
              </p>
            </div>

            <!-- Conversational Registration -->
            <DealerConversationalRegistration
              :show-close-button="false"
              @close="handleRegistrationComplete"
            />

            <!-- Login Link -->
            <div class="text-center mt-8 mb-6">
              <v-divider class="mb-4"></v-divider>
              <p class="body-1 grey--text mb-3">Already have a dealer account?</p>
              <v-btn
                text
                color="primary"
                large
                @click="goToLogin"
              >
                <span class="material-icons-round mr-2">login</span>
                Sign In to Your Dashboard
              </v-btn>
            </div>

            <!-- Benefits Section -->
            <div class="benefits-section mt-8">
              <v-row>
                <v-col cols="12" md="4">
                  <div class="benefit-card text-center">
                    <v-icon size="48" color="success" class="material-icons-round mb-3">
                      trending_up
                    </v-icon>
                    <h3 class="benefit-title">Increase Sales</h3>
                    <p class="benefit-text">
                      Get your inventory in front of 1,000s of active referral agents
                    </p>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="benefit-card text-center">
                    <v-icon size="48" color="info" class="material-icons-round mb-3">
                      network_node
                    </v-icon>
                    <h3 class="benefit-title">Expand Network</h3>
                    <p class="benefit-text">
                      Connect with qualified agents who bring pre-qualified leads
                    </p>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="benefit-card text-center">
                    <v-icon size="48" color="warning" class="material-icons-round mb-3">
                      auto_awesome
                    </v-icon>
                    <h3 class="benefit-title">AI-Powered</h3>
                    <p class="benefit-text">
                      Leverage our AI assistant to match customers with perfect vehicles
                    </p>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Trust Indicators -->
            <div class="trust-section mt-8 text-center">
              <h3 class="trust-title mb-4">Trusted by Leading Dealerships</h3>
              <div class="trust-stats">
                <div class="stat-item">
                  <div class="stat-number">500+</div>
                  <div class="stat-label">Active Dealers</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number">10K+</div>
                  <div class="stat-label">Referral Agents</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number">50K+</div>
                  <div class="stat-label">Vehicles Sold</div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- Footer -->
    <FooterDealer />
  </div>
  </v-app>
</template>

<script>
import HeaderDealer from '@/components/Layout/HeaderDealer.vue'
import FooterDealer from '@/components/Layout/FooterDealer.vue'
import DealerConversationalRegistration from '@/components/DealerConversationalRegistration.vue'

export default {
  name: 'DealerSignup',
  components: {
    HeaderDealer,
    FooterDealer,
    DealerConversationalRegistration
  },
  methods: {
    handleRegistrationComplete() {
      // Handle successful registration
      // Could redirect to login page or show success message
      this.$router.push('/dealers/login');
    },

    goToLogin() {
      this.$router.push('/dealers/login');
    }
  }
}
</script>

<style scoped>
.dealer-signup {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.dealer-signup-main {
  padding-top: 0;
}

.signup-container {
  padding: 40px 20px;
}

.min-height-screen {
  min-height: calc(100vh - 160px);
}

.hero-section {
  margin-bottom: 40px;
}

.hero-icon {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 16px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: #4a5568;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.benefits-section {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 40px 20px;
  backdrop-filter: blur(10px);
}

.benefit-card {
  padding: 20px;
}

.benefit-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 12px;
}

.benefit-text {
  font-size: 1rem;
  color: #4a5568;
  line-height: 1.5;
}

.trust-section {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 40px 20px;
  backdrop-filter: blur(10px);
}

.trust-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
}

.trust-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1976d2;
  line-height: 1;
}

.stat-label {
  font-size: 0.9rem;
  color: #4a5568;
  margin-top: 4px;
  font-weight: 500;
}

.dealer-footer {
  margin-top: auto;
}

.footer-text {
  color: #6b7280;
  font-size: 0.9rem;
}

.footer-link {
  color: #1976d2;
  text-decoration: none;
  margin: 0 4px;
}

.footer-link:hover {
  text-decoration: underline;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .trust-stats {
    gap: 40px;
  }
  
  .stat-number {
    font-size: 2rem;
  }
  
  .signup-container {
    padding: 20px 10px;
  }
  
  .benefits-section,
  .trust-section {
    padding: 30px 15px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.8rem;
  }
  
  .trust-stats {
    gap: 30px;
  }
  
  .stat-number {
    font-size: 1.8rem;
  }
}
</style>
